import { useRef, useEffect } from 'react';
import JsBarcode from 'jsbarcode';

interface BarcodeDisplayProps {
  value: string;
}

function BarcodeDisplay({ value }: BarcodeDisplayProps) {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(function renderBarcode() {
    if (!svgRef.current || !value) return;

    const cleanValue = value.replace(/[.\s-]/g, '');

    try {
      JsBarcode(svgRef.current, cleanValue, {
        format: 'ITF',
        displayValue: false,
        height: 60,
        width: 1,
        margin: 2,
      });
    } catch {
      try {
        JsBarcode(svgRef.current, cleanValue, {
          format: 'CODE128',
          displayValue: false,
          height: 60,
          width: 1,
          margin: 2,
        });
      } catch {
        // Barcode rendering failed silently
      }
    }
  }, [value]);

  return <svg ref={svgRef} />;
}

export default BarcodeDisplay;
